var getEntities = require('./get_entities');

var _require = require('../utils/utils'),
    isPlainObject = _require.isPlainObject;

module.exports = function (ids, languages, props, format, redirects) {
  // Polymorphism: arguments can be passed as an object keys
  if (isPlainObject(ids)) {
    var _ids = ids;
    ids = _ids.ids;
    languages = _ids.languages;
    props = _ids.props;
    format = _ids.format;
    redirects = _ids.redirects;
  }

  if (!(ids instanceof Array)) throw new Error('getManyEntities expects an array of ids');
  return getIdsGroups(ids).map(function (idsGroup) {
    return getEntities(idsGroup, languages, props, format, redirects);
  });
};

var getIdsGroups = function getIdsGroups(ids) {
  var groups = [];

  while (ids.length > 0) {
    var group = ids.slice(0, 50);
    ids = ids.slice(50);
    groups.push(group);
  }

  return groups;
};